import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import { cpf } from "../../../utils/masks";
import { IrmaoTable } from "../../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";
import { generateAddressFiliacao } from "../../../utils/generateAddressFiliacao";

export const ReferenciaFamiliar = ({ data }) => {
  const columnsComunitaria = [
    {
      Header: "Vínculo",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        return (
          <Text whiteSpace={"nowrap"}>
            {
              props?.value.pessoaFisicaReferenciaFamiliarComunitaria
                .tipoReferenciaFamiliar.descricao
            }
          </Text>
        );
      },
      sortType: (rowA, rowB) => {
        const descricaoA =
          rowA?.original?.pessoaFisicaReferenciaFamiliarComunitaria
            ?.tipoReferenciaFamiliar?.descricao;
        const descricaoB =
          rowB?.original?.pessoaFisicaReferenciaFamiliarComunitaria
            ?.tipoReferenciaFamiliar?.descricao;
        return descricaoA.localeCompare(descricaoB, undefined, {
          sensitivity: "base",
        });
      },
    },
    {
      Header: "Nome",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        const nome =
          props?.value?.pessoaFisicaReferenciaFamiliarComunitaria?.nome;
        return (
          <Text
            whiteSpace={{ base: "nowrap", lg: "normal" }}
            wordBreak={nome.length > 45 && "break-all"}
            title={nome}
          >
            {nome}
          </Text>
        );
      },
    },

    {
      Header: "CPF",
      accessor: (row) => {
        return (
          <Text whiteSpace={"nowrap"}>
            {row.pessoaFisicaReferenciaFamiliarComunitaria.cpf &&
              cpf(row.pessoaFisicaReferenciaFamiliarComunitaria.cpf)}
          </Text>
        );
      },
      sortType: "basic",
    },
    {
      Header: "Endereço",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        const endereco = props.value.pessoaFisicaReferenciaFamiliarComunitaria;

        return (
          <Text whiteSpace={{ base: "normal" }} wordBreak={"break-all"}>
            {generateAddressFiliacao(endereco)}
          </Text>
        );
      },
      sortType: (rowA, rowB) => {
        const addressA =
          rowA.original.pessoaFisicaReferenciaFamiliarComunitaria;
        const addressB =
          rowB.original.pessoaFisicaReferenciaFamiliarComunitaria;

        const addressStringA = `${addressA.logradouro}, ${addressA.numeroResidencia}, ${addressA.bairro?.nome}, ${addressA.estado?.nome}-${addressA.estado?.sigla}`;
        const addressStringB = `${addressB.logradouro}, ${addressB.numeroResidencia}, ${addressB.bairro?.nome}, ${addressB.estado?.nome}-${addressB.estado?.sigla}`;

        return addressStringA.localeCompare(addressStringB, undefined, {
          sensitivity: "base",
        });
      },
    },
  ];

  return data && data.length > 0 ? (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Referência Familiar e Comunitária"
          mt="15px"
          py="12px"
          mtDivider="5px"
        >
          <IrmaoTable
            disableHeaderOptions={true}
            columns={columnsComunitaria}
            data={data}
            filiacoes={data}
            entidade="referencia-comunitaria"
            comunitaria={true}
            isPrint={true}
          />
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Referência Familiar e Comunitária"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
